import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.deviceId = ''
      this.username = ''
      this.venueName = ''
      this.startTime = ''
      this.endTime = ''
      this.checkType = ''
      this.checkTime = []
    }
  }
}
export default searchFrom
